import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/retina/welcome1@2x.png")